<template>
	<div class="site-prices">
		<template
			v-for="(pricesGroup, pricesGroupIndex) in [specialPrices, simplePrices]"
		>
			<InfoRow
				v-for="(price, priceIndex) in pricesGroup"
				:key="`${pricesGroupIndex}priceIndex=${priceIndex}`"
				:title="$getDeep(+priceIndex, works)"
				class="site-prices__row"
			>
				<div class="site-prices__inputs vx-row">
					<template v-if="checkPriceSpecial(price)">
						<div
							v-for="(level, levelIndex) in price"
							:key="`priceLevelIndexSpecial=${levelIndex}`"
							class="site-prices__input vx-col w-full sm:w-1/3"
						>
							<vs-input
								v-validate="'required|numeric'"
								:name="`four-pages-price${levelIndex}`"
								:label="`${$getDeep(level.quality_level_id, levels)} (first 4 page)`"
								:value="level.price_first_four_page"
								@input="value => level.price_first_four_page = +value"
								type="number"
								class="w-full"
							/>
							<span class="text-danger text-sm">{{ errors.first('price') }}</span>
						</div>
					</template>
					<div
						v-for="(level, levelIndex) in price"
						:key="`priceLevelIndex=${levelIndex}`"
						class="site-prices__input vx-col w-full sm:w-1/3"
					>
						<vs-input
							v-validate="'required|numeric'"
							:name="`price${levelIndex}`"
							:label="$getDeep(level.quality_level_id, levels)"
							:value="level.price"
							@input="value => level.price = +value"
							type="number"
							class="w-full"
						/>
						<span class="text-danger text-sm">{{ errors.first('price') }}</span>
					</div>
				</div>
			</InfoRow>
		</template>
	</div>
</template>

<script>
import InfoRow from "@/views/Sites/InfoRow";

export default {
	name: "SitePrices",
	props: {
		prices: { type: Object, default: () => ({}) },
		works: { type: Array, default: () => [] },
		levels: { type: Array, default: () => [] },
	},
	components: {
		InfoRow
	},
	computed: {
		simplePrices() {
			return this.getPricesGroup(item => !this.checkPriceSpecial(item));
		},
		specialPrices() {
			return this.getPricesGroup(item => this.checkPriceSpecial(item));
		}
	},
	methods: {
		checkPriceSpecial(price) {
			return price[0].price_first_four_page !== null;
		},
		getPricesGroup(check) {
			let output = {};
			for(let key in this.prices) {
				if(check(this.prices[key])) {
					output[key] = this.prices[key];
				}
			}

			return output;
		}
	},
	mounted() {
		const entries = Object.entries(this.prices);
		if(entries.length) {
			this.$validator.validateAll();
		}
	}
};
</script>

<style lang="scss" scoped>
.site-prices {
	&__row {
		margin-top: 35px;

		&:first-child {
			margin-top: 0;
		}
	}

	&__input {
		margin-bottom: 7px;
	}
}
</style>
